import { render, staticRenderFns } from "./CrearPercepcionCargasFamilia.vue?vue&type=template&id=0f44acbb&scoped=true&"
import script from "./CrearPercepcionCargasFamilia.vue?vue&type=script&lang=js&"
export * from "./CrearPercepcionCargasFamilia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f44acbb",
  null
  
)

export default component.exports